'use client'

import { useParams } from 'next/navigation'
import { useTexts } from '@/contexts/LanguageContext'
import DomainCard from '../../controls/components/DomainCard'
import { CONTROL_COUNT, CONTROL_DOMAINS } from '../../controls/controlDomains'
import { TRUST_CENTER_SECTIONS, trustCenterPath } from '../../utils'
import SectionHeader from './SectionHeader'

const MAX_DOMAINS_TO_SHOW = 8

export default function ControlsOverview() {
  const { CONTROLS } = useTexts().PUBLIC_TRUST_CENTER.OVERVIEW
  const { orgToken } = useParams<{ orgToken: string }>()
  return (
    <section className="flex flex-col gap-3.5 py-8">
      <SectionHeader
        title={CONTROLS.TITLE}
        subtitle={CONTROLS.SUBTITLE(CONTROL_COUNT)}
        link={{ href: trustCenterPath(orgToken, TRUST_CENTER_SECTIONS.CONTROLS), label: CONTROLS.VIEW_ALL }}
      />
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {CONTROL_DOMAINS.slice(0, MAX_DOMAINS_TO_SHOW).map((domain) => (
          <DomainCard key={domain.id} domain={domain} />
        ))}
      </div>
    </section>
  )
}
